<template>
    <edit-resource
        :title="title"
        :form="form"
        @close="$emit('close')"
        @submit="saveQuote">

        <div class="w-600">
            <translatable #default="{ languages, selectedLanguage }" :errors="warningTabs">
                <div v-for="lang in languages" :key="lang">
                    <simple-textarea
                        v-show="lang === selectedLanguage"
                        v-model="form.content[lang]">
                    </simple-textarea>
                </div>
            </translatable>
        </div>
    </edit-resource>
</template>


<script>
import EditResource from './EditResource.vue';
import Input from '../forms/Input.vue';
import Form from '../../etc/forms/Form';
import TextArea from '../forms/TextArea.vue';
import Translatable from '../forms/Translatable.vue';
import * as quotes from '../../services/QuoteService';
import Quote from '../../models/Quote';
import { normalizeJson } from '../../../shared/helpers';
import {mapState} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';

let fieldDefaults = () => [
    { name: 'content', value: {}, rules: ['required']},
];

export default {
    components: {
        'edit-resource': EditResource,
        'simple-textarea': TextArea,
        'translatable': Translatable,
    },
    props: {
        quote: Object,
    },
    data: function () {
        return {
            form: this.generateForm(),
            savingQuote: false,
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        title () {
            return this.$t(this.quote ? 'general.edit_subject' : 'general.add_subject', { subject: this.$t('components.quote') })
        },
        warningTabs() {
            let languages = this.currentCompany.jobsite.active_languages;
            let errorLang = [];

            for (let index in languages) {
                if (!this.form.data.content[languages[index]]) {
                    errorLang.push(languages[index]);
                }
            }
            return errorLang;
        },
    },
    methods: {
        generateForm () {

            let fields = fieldDefaults();

            if (this.quote) {
                fields.forEach((field, index) => {
                    fields[index].value = JSON.parse(JSON.stringify(this.quote[field.name]));
                });
            }

            return new Form(fields);
        },

        async saveQuote () {

            if (this.quote && this.quote.id) {
                await this.updateQuote();
            } else {
                let results = await this.createQuote();

                if (!Array.isArray(results)) {
                    results = [results];
                }

                results.forEach(item => {
                    this.$emit('created', item.id);
                });
            }

            this.$emit('close');
        },
        updateQuote () {
            return this.form.submit(data => quotes.update(this.quote.id, {
                data: {
                    type: 'quotes',
                    attributes: data,
                },
            })).then(result => {
                return useRepo(Quote).save(normalizeJson(result));
            });
        },
        createQuote () {
            return this.form.submit(data => quotes.store({
                data: {
                    type: 'quotes',
                    attributes: data,
                },
            })).then(result => {
                return useRepo(Quote).save(normalizeJson(result));
            });
        },
    }
}
</script>
